export const environment = {
    production: true,
    server: "http://sonovision.southeastasia.cloudapp.azure.com/api"
    // server: "https://ibooking-198019.appspot.com/api"
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts